var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoto(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0755 2.88675C20.1695 1.10042 23.9815 1.10042 27.0755 2.88675L36.1934 8.15099C39.2874 9.93732 41.1934 13.2386 41.1934 16.8112V27.3397C41.1934 30.9124 39.2874 34.2136 36.1934 36L27.0755 41.2642C23.9815 43.0505 20.1695 43.0505 17.0755 41.2642L7.95755 36C4.86354 34.2136 2.95755 30.9124 2.95755 27.3397V16.8112C2.95755 13.2386 4.86354 9.93731 7.95755 8.15098L17.0755 2.88675Z",
    fill: "#05C6C5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.394 28.0377L21 22.5189L26.394 17",
    fill: "#05C6C5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9245 22.5189H21M21 22.5189L26.394 28.0377M21 22.5189L26.394 17",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoto);
export default __webpack_public_path__ + "static/media/goto.f553bb98f3a2b1733257609aee20de33.svg";
export { ForwardRef as ReactComponent };